import {
  PostAddOutlined as PostAddOutlinedIcon,
  MedicationOutlined as MedicationOutlinedIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { SvgIcon, Button } from "@mui/material";
import { useAuth } from "../../../auth/context";
import { useIsInQuickLink } from "../../../utils/hooks";

const buttons = [
  {
    name: "Nueva Receta",
    icon: <PostAddOutlinedIcon />,
    redirect: "/prescriptions/new",
  },
  {
    name: "Nueva Orden",
    icon: <MedicationOutlinedIcon />,
    redirect: "/orders/new",
  },
];

const styleBtn = {
  backgroundColor: "secondaryGreen.main",
  mr: 0.5,
  ml: 0.5,
  "&:hover": {
    backgroundColor: "#4AB0A6",
  },
};

export default ({ patientId }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isInQuickLink = useIsInQuickLink();

  if (!user.canPrescribe() || isInQuickLink) return;

  return (
    <>
      {buttons.map(({ name, icon, redirect }) => (
        <Button
          key={name}
          size="small"
          variant="contained"
          sx={styleBtn}
          onClick={() => navigate(`${redirect}/?patientId=${patientId || ""}`)}
        >
          <SvgIcon sx={{ fontSize: 20 }}>{icon}</SvgIcon>
          {name}
        </Button>
      ))}
    </>
  )
};
